import { z } from "zod";

import { DbEnum } from "../../../../generated/prisma-enums";
import { EmbedDeploymentSettingsSchema } from "../../../../schemas/Deployment/deploymentSettings/Embed/__json.schema";

/**
 * Create Deployment Body Schema
 *
 * Data required to create a new deployment.
 * organizationId comes from auth context, not body.
 *
 * deploymentSettings validation:
 * - EMBED: Fully validated with EmbedDeploymentSettingsSchema
 * - Others: Accept Record<string, unknown> for now (TODO: add schemas for each type)
 */
export const CreateDeploymentBodySchema = z.object({
  name: z.string().trim().min(1).max(255),
  description: z.string().max(1000).optional(),
  type: z.nativeEnum(DbEnum.DeploymentType),
  agentId: z.string().uuid().optional(), // now a column (FK to Agent)
  deploymentSettings: z.union([
    EmbedDeploymentSettingsSchema, // EMBED type fully validated
    z.record(z.string(), z.unknown()) // Other types (TODO: add schemas)
  ]),
  phoneNumberId: z.string().uuid().optional(),
  oauthConnectionId: z.string().uuid().optional(),
  apiKeyConnectionId: z.string().uuid().optional(),
  // WhatsApp-specific: Backend resolves phoneNumberId + apiKeyConnectionId from sender
  whatsappSenderId: z.string().optional(),
  /**
   * Create even though another active WhatsApp deployment already serves this
   * sender, detaching that one.
   *
   * Without it the backend answers 409 `WHATSAPP_SENDER_IN_USE`, carrying the
   * current owner so the client can name it in a confirmation. Mirrors the same
   * field on Update — a number serves one deployment, and which one it is
   * should never change without someone saying so.
   */
  force: z.boolean().optional()
});

export type CreateDeploymentBody = z.infer<typeof CreateDeploymentBodySchema>;
